export const environment = {
    production: false,
    serviceWorker: true,
    endpoint: 'https://bat-admin-api.stg.pardgroup.com',
    cdn: 'https://bat-cdn.stg.pardgroup.com'
};
